import moment from "moment-timezone";

/**
 * LF360-1940 — the earliest a fixed reminder may be, in minutes since midnight.
 *
 * A task assigned for today cannot carry a reminder that has already gone: the
 * backend refuses one, counting in the SUBJECT'S timezone, and the picker has to
 * disable the same rows or the rule only shows up as a 400.
 *
 * The subject's day, not the admin's. An admin in Kyiv at 14:30 assigning to a
 * subject in Auckland is working inside that subject's tomorrow, where nothing
 * has passed at all; the same admin assigning to a subject beside them cannot
 * pick 12:30. Both halves come out of this one function so the two drawers
 * cannot drift from each other or from the backend.
 *
 * @param {object|null} date the chosen date, a dayjs or moment
 * @param {string} timeZone the subject's timezone
 * @returns {number|null} minutes since local midnight, or null when the date is
 *   not today there and every hour is fair game
 */
export const earliestTimeToday = (date, timeZone) => {
  if (!date || typeof date.format !== "function") { return null; }

  const zone = timeZone || "UTC";
  const now = moment.tz(zone);

  if (date.format("YYYY-MM-DD") !== now.format("YYYY-MM-DD")) { return null; }

  // The next minute: this one is already going.
  return now.hours() * 60 + now.minutes() + 1;
};

export default earliestTimeToday;
